// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @typedef {Object} DialogOpts
 * @property {number} dialogMaxWidth
 * @property {string} progressColor
 * @property {number} progressSize
 * @property {number} progressWidth
 */

export const DEFAULT_OPTIONS = {
  dialogMaxWidth: 250,
  progressColor: 'primary',
  progressSize: 45,
  progressWidth: 5
};

/**
 * @typedef {Object} LoaderConfig
 * @property {string} title
 * @property {string} text
 * @property {boolean} loading
 * @property {boolean} opaque
 * @property {DialogOpts} opts
 */

const state = {
  loading: false,
  opaque: false,
  title: '',
  text: '',
  options: { ...DEFAULT_OPTIONS }
};

export default state;
